module.exports = __webpack_public_path__ + "img/introduction_media_02.4c75e324.jpg";